
import React from "react";
import ReactDOM from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import theme from "./theme";
import { store, persistor } from "./store/store";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "./locales/i18n";
import "./fonts.css";
import "./services/GlobalNetworkMonitor"; // Initialize global network monitoring
import { getFaviconPath } from "./utils/commonMethods";

// Set document title from env
document.title = import.meta.env.VITE_APP_PROJECT_NAME;

// Set favicon dynamically based on APP_NAME
getFaviconPath();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
